import { useCallback } from "react";
import classnames from "classnames";
import CardArtwork from "@/components/Card/CardArtwork";
import { FavoriteButton } from "@/components/Buttons/index";
import styles from "@/styles/Row.module.scss";
import routes from "@/lib/routes";
import Link from "next/link";

export default function ChannelListRow({ item }) {
  const handleClick = useCallback(
    (e) => {
      if (!item.isAllowedRating) {
        e.preventDefault();
      }
    },
    [item]
  );

  return (
    <div
      className={classnames(styles.container, styles.list, {
        [styles.notAllowed]: !item.isAllowedRating,
      })}
    >
      <div className={styles.inner}>
        <div className={styles.artwork}>
          <CardArtwork
            item={item}
            className={styles.artworkInner}
            href={routes.channelDetail(item.id)}
            linkAttr={{ onClick: handleClick }}
          />
        </div>
        <div className={styles.info}>
          <h4 className={styles.title}>
            <Link href={routes.channelDetail(item.id)} onClick={handleClick}>
              {item.name}
            </Link>
          </h4>
          <div className={styles.genre}>
            <span>{item.genres.map((genre) => genre.name).join("/")}</span>
          </div>
          <p className={styles.description}>{item.description}</p>
        </div>
        <div>
          <FavoriteButton listRow metaId={item.id} />
        </div>
      </div>
    </div>
  );
}
